<scitis-app-global-page-header [pageTitle]="'Trigger configuration'">
  <ng-template #filterElement>
    <button (click)="onAddTriggerConfiguration()" [disabled]="isAddTriggerConfigurationButtonDisabled"
      class="btn btn-primary">
      <span class="fa-solid fa-plus"></span>
      <span translate>New trigger configuration</span>
    </button>
  </ng-template>
</scitis-app-global-page-header>


<div class="card card-table-view mb-3">
  <div class="card-body">
    <div class="table-responsive-md">
      <table class="table vertical-align-middle mb-0">
        <thead>
          <tr>
            <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="name">
              <span translate>Name</span>
            </th>
            <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="triggerType">
              <span translate>Trigger type</span>
            </th>
            <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="lastExecution">
              <span translate>Last executed</span>
            </th>
            <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="isActive">
              <span translate>Active</span>
            </th>
            <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="triggerQueries">
              <span translate>Trigger actions</span>
            </th>

            <th class="text-right" scope="col">
              <span translate>Action</span>
            </th>
          </tr>
        </thead>
        <tbody>

          @for (triggerConfiguration of triggerConfigurationList; track triggerConfiguration) {
            <tr>
              <td>
                <b>
                  <ngb-highlight [result]="triggerConfiguration.name" [term]="''"></ngb-highlight>
                </b>
              </td>
              <td>
                <ngb-highlight [result]="triggerConfiguration.triggerType" [term]="''"></ngb-highlight>
              </td>
              <td [innerText]="triggerConfiguration.lastExecution | date:'dd.MM.yyyy, HH:mm'">
              </td>
              <td>
                @if (!isGapDetectionInProgress[triggerConfiguration.id]) {
                  <span
                    [ngClass]="getBadgeCssClass(triggerConfiguration.isActive)" class="badge">
                    <span [ngClass]="getCircleCssClass(triggerConfiguration.isActive)"
                    class="fa mr-1"></span>
                    <span [innerText]="getActiveWord(triggerConfiguration.isActive)"></span>
                  </span>
                }
                @if (isGapDetectionInProgress[triggerConfiguration.id]) {
                  <span class="badge badge-dark">
                    <span class="fa-solid fa-spin fa-spinner"></span>{{'Gap detection in progress' | translate}}</span>
                  }
                </td>
                <td>
                  <ul class="small mb-0 pl-3">
                    @for (m of triggerConfiguration.triggerQueries; track m) {
                      <li [innerText]="m.name"></li>
                    }
                  </ul>
                </td>
                <td class="text-right">
                  <scitis-admin-trigger-configuration-action (deleteEvent)="onDeleteTriggerConfiguration($event)"
                    (updatedTriggerConfigurationEvent)="onUpdatedTriggerConfiguration($event)"
                    [userRole]="userRole"
                    [isGapDetectionInProgress]="isGapDetectionInProgress"
                    [isTriggerActivatable]="isTriggerActivatable[triggerConfiguration.id]"
                    [machine]="machine"
                    [triggerConfiguration]="getTriggerConfiguration(triggerConfiguration)">
                  </scitis-admin-trigger-configuration-action>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
